import * as React from "react";
import { motion } from "framer-motion";

type MenuToggleProps = {
    toggle: () => void;
    isOpen: boolean;
};

type PathProps = {
    d?: string;
    transition?: any;
    variants: any;
};

const Path = (props: PathProps) => (
  <motion.path
    fill="transparent"
    strokeWidth="3"
    stroke="#8b7660"
    strokeLinecap="round"
    {...props}
  />
);

export const MenuToggle = ({ toggle, isOpen }: MenuToggleProps) => (
  <button onClick={toggle} aria-label={isOpen ? "Close menu" : "Open menu"} style={{ background: 'transparent', border: 'none', outline: 'none', cursor: 'pointer', padding: 0 }}>
    <motion.svg width="32" height="32" viewBox="0 0 23 23" animate={isOpen ? "open" : "closed"}>
      <Path
        variants={{
          closed: { d: "M 2 2.5 L 20 2.5" },
          open: { d: "M 3 16.5 L 17 2.5" }
        }}
      />
      <Path
        d="M 2 9.423 L 20 9.423"
        variants={{
          closed: { opacity: 1 },
          open: { opacity: 0 }
        }}
        transition={{ duration: 0.1 }}
      />
      <Path
        variants={{
          closed: { d: "M 2 16.346 L 20 16.346" },
          open: { d: "M 3 2.5 L 17 16.346" }
        }}
      />
    </motion.svg>
  </button>
);
